import { SWOTType } from "./interface";

const swotLabels=(translate:Function) => 
	({
		importance:[	
			{value: "1", label: `${translate("Sem importância")} (1 pt)`}, 
			{value: "2", label: `${translate("Menos importante")} (2 pt)`},
			{value: "3", label: `${translate("Importante")} (3 pt)`},
			{value: "4", label: `${translate("Mais importante")} (4 pt)`},
			{value: "5", label: `${translate("Totalmente importante")} (5 pt)`}
		],
		intensity:[
			{value: "1", label: `${translate("Muito fraca")} (1 pt)`}, 
			{value: "2", label: `${translate("Fraca")} (2 pt)`},
			{value: "3", label: `${translate("Média")} (3 pt)`},
			{value: "4", label: `${translate("Forte")} (4 pt)`},
			{value: "5", label: `${translate("Muito forte")} (5 pt)`}
		],
    
		urgency:[
			{value: "1", label: `${translate("Sem urgência")} (1 pt)`}, 
			{value: "2", label: `${translate("Menos urgente")} (2 pt)`},
			{value: "3", label: `${translate("Urgente")} (3 pt)`},
			{value: "4", label: `${translate("Muito urgente")} (4 pt)`},
			{value: "5", label: `${translate("Totalmente urgente")} (5 pt)`}
		],
    
		tendencyAnalysis:[
			{value: "1", label: `${translate("Muito fraca")} (1 pt)`}, 
			{value: "2", label: `${translate("Fraca")} (2 pt)`},
			{value: "3", label: `${translate("Média")} (3 pt)`},
			{value: "4", label: `${translate("Forte")} (4 pt)`},
			{value: "5", label: `${translate("Muito forte")} (5 pt)`}
		],

		// tendency for strength and oportunities
		tendencySO:[
			{value: "1", label: `${translate("Piora muito")} (1 pt)`}, 
			{value: "2", label: `${translate("Piora")} (2 pt)`},
			{value: "3", label: `${translate("Mantém")} (3 pt)`},
			{value: "4", label: `${translate("Melhora")} (4 pt)`},
			{value: "5", label: `${translate("Melhora muito")} (5 pt)`}
		],
    
		// tendency for weakness and threats
		tendencyWT:[
			{value: "1", label: `${translate("Melhora muito")} (1 pt)`}, 
			{value: "2", label: `${translate("Melhora")} (2 pt)`},
			{value: "3", label: `${translate("Mantém")} (3 pt)`},
			{value: "4", label: `${translate("Piora")} (4 pt)`},
			{value: "5", label: `${translate("Piora muito")} (5 pt)`}
		],
		swotSections :[
			{type:SWOTType.STRENGTHS,title:translate("Forças"),color:"var(--green)"},
			{type:SWOTType.WEAKNESSES,title:translate("Fraquezas"),color:"var(--blue)"},
			{type:SWOTType.OPPORTUNITIES,title:translate("Oportunidades"),color:"var(--red)"},
			{type:SWOTType.THREATS,title:translate("Ameaças"),color:"var(--yellow)"}
		]
	});

export const useIntensity = (type:SWOTType) =>  type === SWOTType.STRENGTHS ||type === SWOTType.WEAKNESSES;

export const useTendencySO = (type:SWOTType) =>  type === SWOTType.STRENGTHS ||type === SWOTType.OPPORTUNITIES;

export default swotLabels;
